import * as React from "react";

const Tony = () => {
    return (
      <ol className="references">
         <li>
            Centers for Disease Control and Prevention. HIV in the southern United States. Published September 2019. Accessed February 2, 2022.&nbsp;  
            <a target="_blank" className="" href="https://www.cdc.gov/hiv/pdf/policies/cdc-hiv-in-the-south-issue-brief.pdf">https://www.cdc.gov/hiv/pdf/policies/cdc-hiv-in-the-south-issue-brief.pdf</a>
          </li>
         <li>
         Marano M, Stein R, Song W, et al. HIV testing, linkage to HIV medical care, and interviews for partner services among Black men who have sex with men - non-health care facilities, 20 Southern U.S. jurisdictions, 2016. <i>MMWR Morb Mortal Wkly Rep.</i> 2018;67(28):778-781.
          </li>
         <li>
         Centers for Disease Control and Prevention. HIV and African American gay and bisexual men. December 2021. Accessed February 4, 2022.&nbsp;
            <a target="_blank" className="" href="https://www.cdc.gov/hiv/pdf/group/msm/cdc-hiv-bmsm.pdf">https://www.cdc.gov/hiv/pdf/group/msm/cdc-hiv-bmsm.pdf</a>
          </li>
         <li>
          Reif S, Safley D, McAllaster C, Wilson E, Whetten K. State of HIV in the US deep south. <i>J Community Health</i>. 2017;42(5):844-853.
          </li>
          <li>
            HIV.gov. Standing up to stigma. Published February 24, 2020. Accessed February 17, 2022.&nbsp;
            <a target="_blank" className="" href="https://www.hiv.gov/hiv-basics/overview/making-a-difference/standing-up-to-stigma#:~:text=Almost%208%20in%2010%20adults%20with%20HIV%20receiving,ability%20to%20stay%20adherent%20to%20their%20HIV%20medication">https://www.hiv.gov/hiv-basics/overview/making-a-difference/standing-up-to-stigma#:~:text=Almost%208%20in%2010%20adults%20with%20HIV%20receiving,ability%20to%20stay%20adherent%20to%20their%20HIV%20medication</a>
          </li>
         <li>
         Rueda S, Mitra S, Chen S, et al. Examining the associations between HIV-related stigma and health outcomes in people living with HIV/AIDS: a series of meta-analyses. <i>BMJ Open</i>. 2016;6(7):e011453.
          </li>

          <li>
          HIV.gov. Limitations to treatment safety and efficacy: adherence to the continuum of care. Reviewed October 17, 2017. Accessed February 2, 2022.&nbsp;
            <a target="_blank" className="" href="https://clinicalinfo.hiv.gov/sites/default/files/guidelines/documents/AdultARV_GL_AdherenceTable19.pdf">https://clinicalinfo.hiv.gov/sites/default/files/guidelines/documents/AdultARV_GL_AdherenceTable19.pdf</a>
          </li>
         <li>
         Pellowski JA. Barriers to care for rural people living with HIV: a review of domestic research and health care models. <i>J Assoc Nurses AIDS Care</i>. 2013;24(5):422-437.
          </li>
         <li>
         Kimmel AD, Masiano SP, Bono RS, et al. Structural barriers to comprehensive, coordinated HIV care: geographic accessibility in the US South. <i>AIDS Care</i>. 2018;30(11):1459-1468.
          </li>
          <li>
          Alabama Arise. Fact Sheet: Jump-start public transit in Alabama. Published December 22, 2021. Accessed February 2, 2022.&nbsp;
            <a target="_blank" className="" href="https://www.alarise.org/resources/jump-start-public-transit-in-alabama-2/">https://www.alarise.org/resources/jump-start-public-transit-in-alabama-2/</a>
          </li>
      </ol>
    )
  }

export default Tony;